var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.047 22.9528C18.4435 20.3493 14.2224 20.3493 11.6189 22.9528M21.333 12.6667H21.3163M11.333 12.6667H11.3163M1.33301 16.0001C1.33301 24.2843 8.04874 31 16.333 31C24.6173 31 31.333 24.2843 31.333 16.0001C31.333 7.71583 24.6173 1.00012 16.333 1.00012C8.04874 1.00012 1.33301 7.71583 1.33301 16.0001Z",
    stroke: "#EE5D50",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.83c1855aa5aa4514cd145c1ea671e212.svg";
export { ForwardRef as ReactComponent };